/**
 * Branding Configuration
 * 
 * This file contains all company-specific branding settings.
 * Update these values when deploying to a new company.
 */

export interface BrandingConfig {
  /** Company name (appears in title, headers, etc.) */
  companyName: string;
  
  /** Short company name for space-constrained areas */
  companyShortName: string;
  
  /** Application title suffix */
  appTitle: string;
  
  /** Primary brand color (hex) */
  primaryColor: string;
  
  /** Secondary brand color (hex) */
  secondaryColor: string;
  
  /** Company website URL (optional) */
  website?: string;
  
  /** Support email (optional) */
  supportEmail?: string;
}

/**
 * BTC branding configuration
 */
const btcBranding: BrandingConfig = {
  companyName: 'BTC Business Suite',
  companyShortName: 'BTC',
  appTitle: 'BTC Business Suite',
  primaryColor: '#2563eb', // blue-600
  secondaryColor: '#1e40af', // blue-700
  website: 'https://intel.butlertc.com',
  supportEmail: 'support@butlertc.com',
};

/**
 * Saturn branding configuration
 */
const saturnBranding: BrandingConfig = {
  companyName: 'Saturn Business Suite',
  companyShortName: 'Saturn',
  appTitle: 'Saturn Business Suite',
  primaryColor: '#7c3aed', // violet-600
  secondaryColor: '#6d28d9', // violet-700
  website: 'https://saturn.butlertc.com',
  supportEmail: 'support@butlertc.com',
};

/**
 * Export appropriate branding based on build-time environment variable
 * Set via Cloudflare Pages environment variables: VITE_COMPANY=saturn
 */
const company = import.meta.env.VITE_COMPANY || 'btc';

export const branding: BrandingConfig = company === 'saturn' ? saturnBranding : btcBranding;
